import { useNewChat } from "@hooks:useNewChat";
import { Box } from "@mui/material";
import { Tab } from "@pages:app/talk/const";
import { Sidebar } from "@pages:app/talk/Sidebar/Sidebar";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";

import { Routes } from "@:constants";

interface TalkProps {
  children?: ReactNode;
}

export const TalkLayout = ({ children }: TalkProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { newChat } = useNewChat();

  const tab = location.pathname.includes(Routes.AppSearch)
    ? Tab.Search
    : Tab.Chat;

  const setTab = (newTab: Tab) => {
    if (newTab === Tab.Search) {
      navigate(Routes.AppSearch);
    } else {
      newChat();
    }
  };

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "300px",
          minWidth: "300px",
        }}
      >
        <Sidebar tab={tab} setTab={setTab} />
      </Box>
      <Box
        sx={{
          height: "100vh",
          minHeight: "100vh",
          padding: "12px",
          display: "flex",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
